import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './LanguageSelector';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const navLinks = [
    { label: t('nav.home'), id: 'home' },
    { label: t('nav.aboutUs'), id: 'about' },
    { label: t('nav.services'), id: 'services' },
    { label: t('nav.portfolio'), id: 'portfolio' },
    { label: t('nav.salesLeadsPro'), id: 'sales-leads-pro', isExternal: true },
    { label: t('nav.contact'), id: 'contact' }
  ];

  return (
    <header 
      className="dark-header"
      style={{
        background: scrolled ? 'rgba(255, 255, 255, 0.98)' : '#FFFFFF',
        backdropFilter: scrolled ? 'blur(10px)' : 'none',
        transition: 'all 0.3s ease'
      }}
    >
      <div className="dark-logo-container" onClick={() => scrollToSection('home')} style={{ cursor: 'pointer' }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }}>
          <div style={{
            fontSize: '18px',
            fontWeight: '700',
            color: '#0D2C22',
            letterSpacing: '0.5px',
            lineHeight: '1.1'
          }}>
            Logardt Group
          </div>
          <div style={{
            fontSize: '9px',
            color: 'rgba(13, 44, 34, 0.6)',
            letterSpacing: '0.8px',
            textTransform: 'uppercase',
            marginTop: '2px'
          }}>
            Consulting | Web Development | AI Solutions
          </div>
        </div>
      </div>
      
      <nav className="dark-nav">
        {navLinks.map((link) => (
          link.isExternal ? (
            <Link
              key={link.id}
              to={`/${link.id}`}
              className="dark-nav-link"
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                textDecoration: 'none',
                color: link.id === 'sales-leads-pro' ? '#E5A93D' : 'inherit',
                fontWeight: link.id === 'sales-leads-pro' ? '600' : 'inherit'
              }}
            >
              {link.label}
            </Link>
          ) : (
            <button
              key={link.id}
              onClick={() => scrollToSection(link.id)}
              className="dark-nav-link"
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer'
              }}
            >
              {link.label}
            </button>
          )
        ))}
        <LanguageSelector />
      </nav>
    </header>
  );
};

export default Header;
